module.exports = __webpack_public_path__ + "static/media/officine-meccaniche-italiane-reggiane.b91274ae.svg";